import axios from "axios";

const financerPlansUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/financer-plans/backoffice`;
const financerPlansBaseUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/financer-plans`;

function urlManager(url = null, product = null) {
  if (url !== null){
    let urlManager = url
    if (product !== null) {
      urlManager = `${process.env.REACT_APP_BASE_URL}/proxy/${product}/services${urlManager.split('/services').pop()}`
    }
    return urlManager
  }
}

export const getFinancerPlans = async (token, displayError = () => {}, params) => {
  let url = `${financerPlansUrl}${params?.query || params?.page ? "?" : ""}${
    params?.query && params?.query !== "" ? `search=` + params?.query : ``
  }${params?.query && params?.page ? `&` : ""}${
    params?.page ? `page=` + params?.page : ``
  }`;
  return await axios
    .get(url, { headers: { authorization: `Bearer ${token}` } })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("getFinancerPlans error: " + error.message);
    });
};

export const editFinancerPlan = async (token, data, displayError = () => {}) => {
  return await axios
    .put(`${urlManager(financerPlansBaseUrl,'mediline')}/${data?.id}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("editFinancerPlan error: " + error.message);
    });
};

export const activateFinancerPlan = async (token, data, displayError = () => {}) => {
  return await axios
    .post(
      `${urlManager(financerPlansUrl,'mediline')}/${data?.id}`,
      { ...data, activated: true },
      { headers: { authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("activateFinancerPlan error: " + error.message);
    });
};

export const disableFinancerPlan = async (
  token,
  id,
  reason,
  displayError = () => {}
) => {
  return await axios
    .delete(`${urlManager(financerPlansUrl,'mediline')}/${id}/${reason}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("disableFinancerPlan error: " + error.message);
    });
};

export const createFinancerPlan = async (token, data, displayError = () => {}) => {
  return await axios
    .post(`${urlManager(financerPlansBaseUrl,'mediline')}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("createFinancerPlan error: " + error.message);
    });
};

export const getFinancerPlanById = async (token, id, displayError = () => {}) => {
  return await axios
    .get(`${financerPlansBaseUrl}/financer/${id}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("getFinancerPlanByFinancerId error: " + error.message);
    });
};

export const deleteFinancerPlan = async (token, id, displayError = () => {}) => {
  return await axios
    .delete(`${urlManager(financerPlansBaseUrl,'mediline')}/${id}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("deleteFinancerPlan error: " + error.message);
    });
};